import styled from "styled-components";

export const Content = styled.div`
  display: grid;
  margin: 0 1rem;
  @media only screen and (min-width: 1100px) {
    grid-template-columns: 1fr 10fr;
  }
`;

export const WrapperImg = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;

  button {
    border: 1px solid white;
    color: white;
    height: 1.5rem;
    width: 100px;
    @media only screen and (max-width: 1100px) {
      margin-bottom: 1rem;
    }
  }
`;

export const WrapperStatus = styled.div`
  display: grid;
  justify-content: end;
  align-items: center;

  @media only screen and (max-width: 1100px) {
    align-items: center;
    justify-content: center;
  }

  button {
    border: 1px solid white;
    color: white;
    height: 1.5rem;
    width: 100px;
    margin-right: 1rem;
  }
`;

export const Wrapper = styled.div`
  @media only screen and (min-width: 1100px) {
    display: grid;
    align-self: center;
    height: 50px;
    grid-template-columns: 1fr 1fr;
    margin-top: 1.5rem;

    .value-label {
      display: grid;
      grid-template-columns: 1fr 1fr;

      .flex {
        display: flex;
      }
    }

    .initial-value {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    .final_value {
      input {
        width: 110px;
      }
    }

    label > .label {
      text-align: right;
      margin-right: 0.5rem;
    }
  }

  .label {
    font-size: 11px;
    font-weight: 500;
    text-align: left;
  }

  label {
    display: grid;
    grid-template-columns: 1fr 3fr;
    text-align: left;

    @media only screen and (max-width: 600px) {
      grid-template-columns: 1fr;
      .label {
        display: none;
      }
    }
  }

  .wrapper-date {
    display: grid;
    grid-template-columns: 1fr;
  }

  .btnAdd {
    width: 100%;
    display: flex;
    justify-content: right;
    margin-top: 1rem;
  }
`;
